import { TermsCopy } from '@components/ui';
import Typography from '@mui/material/Typography';
export function OtherLegacyServicesSection(): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.0" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.1" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.2" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.3" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.4" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.5" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.otherLegacyServices.6" />
      </Typography>
    </>
  );
}
